import React, { useState, useCallback, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  DataTable,
  Stack,
  Spinner,
  EmptyState,
  Heading,
  Icon,
} from '@shopify/polaris';
import { MobileBackArrowMajor } from '@shopify/polaris-icons';
import LoadingScreen from '../LoadingScreen';
import { DomainContext } from '../domain-context';
import PixelIcon from '../../assets/images/PixelIcon';

const Bundles = ({ handleForm, handleBack, i18n }) => {
  const { domain } = useContext(DomainContext);
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/bundle_groups?shopify_domain=${domain}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((data) => {
        setBundles(data);
        setLoading(false);
      });
  }, []);

  const removeBundleGroup = (id) => {
    fetch(`/bundle_groups/${id}?shopify_domain=${domain}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          const newBundles = [...bundles];
          const removedBundle = newBundles.indexOf(newBundles.find(b => b.id == id))
          newBundles.splice(removedBundle, 1);
          setBundles(newBundles);
        }
      });
  }

  return (
    <>
      <Card title={
        <div className="heading_title">
          <PixelIcon />
          Bundles
        </div>}
        sectioned
      >
        <Stack>
          <Heading>My Bundles</Heading>
          <Stack.Item fill />
          <Button primary onClick={() => handleForm('')}>
            {i18n.t('create_bundle')}
          </Button>
        </Stack>
        <br />
        {loading ? (
          <LoadingScreen />
        ) : bundles.length === 0 ? (
          <EmptyState
            heading="Generate Bundles"
            action={{
              content: 'Create bundle',
              onAction: () => handleForm(''),
            }}
            image="/not_found.png"
          >
            <p>Create bundles for your customers.</p>
          </EmptyState>
        ) : (
          <DataTable
            columnContentTypes={['text', 'text', 'text']}
            headings={['Name', 'Location', '']}
            rows={
              !loading && bundles && bundles.length > 0
                ? bundles.map((bundle) => [
                  bundle.internal_name,
                  bundle?.location?.replace('_', ' '),
                  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <Button primary onClick={() => handleForm(bundle.id)}>
                      Edit
                    </Button>
                    <Button destructive onClick={() => removeBundleGroup(bundle.id)}>
                      Delete
                    </Button>
                  </div>
                ])
                : []
            }
          />
        )}
      </Card>
    </>
  );
};

export default Bundles;
